var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 41,
    viewBox: "0 0 46 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8799 12.2962L22.4591 1.35778C23.4242 0.178149 25.0328 -0.250807 26.4269 0.392627L29.2151 1.6795C30.6092 2.32293 31.3599 3.82428 31.0382 5.32562L29.6441 11.5455C29.4296 12.4034 30.073 13.2613 30.9309 13.2613L40.4752 13.6903C44.3358 13.9047 46.8023 17.8726 45.1937 21.4115L39.1883 34.9236C37.5798 38.4625 34.1481 40.7145 30.2875 40.7145H16.4537C14.7378 40.7145 13.3437 39.3204 13.3437 37.6046V14.2265C13.2365 13.4758 13.451 12.8324 13.8799 12.2962Z",
    fill: "#595757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87038 16.1569V38.7843C7.87038 39.7495 7.01247 40.3929 6.04732 40.0712L4.43873 39.6422C2.18671 38.8916 0.578125 36.854 0.578125 34.3875V20.6609C0.578125 18.4089 1.86499 16.4786 4.00977 15.6207L5.94008 14.7628C6.90523 14.4411 7.87038 15.0845 7.87038 16.1569Z",
    fill: "#595757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLike);
export default __webpack_public_path__ + "static/media/icon_like.2b0acf926ed34b825f65ddf3f4bb0b36.svg";
export { ForwardRef as ReactComponent };